<template>
  <el-table :data="tableData" stripe style="width: 100%" ref="stationTable" border v-loading="stationsLoading">
    <af-table-column prop="id" label="充电站编号"></af-table-column>
    <af-table-column prop="stationName" label="充电站名称"></af-table-column>
    <af-table-column prop="stationCode" label="充电站代码"></af-table-column>
    <af-table-column prop="operatorName" label="运营商"></af-table-column>
    <af-table-column prop="city" label="所在地"></af-table-column>
    <af-table-column width="60" prop="pileCount" label="桩数量"></af-table-column>
    <af-table-column width="80" prop="dutyPerson" label="负责人"></af-table-column>
    <af-table-column width="100" prop="dutyPersonPhone" label="负责人手机号"></af-table-column>
    <af-table-column prop="serviceBillingRulesName"   label="费率组"></af-table-column>
    <af-table-column width="60" prop="stationType.message" label="类型"></af-table-column>
    <af-table-column width="100" label="运行状态">
      <template slot-scope="{row}">
        <div v-if="row.stationStatus">
          <el-tag :type="row.stationStatus.code | statusFilter">
            {{ row.stationStatus.message }}
          </el-tag>
        </div>
      </template>
    </af-table-column>
    <!--                <af-table-column width="80" prop="canUse.message" label="是否启用"></af-table-column>-->
    <af-table-column width="150px" label="当前地锁停车费率">
      <template slot-scope="scope">
        <div v-if="scope.row.parkPrices">
              <span
                style="display: inline-block"
                v-for="(item, i) in JSON.parse(scope.row.parkPrices)"
                :key="i"
              >
                {{ item[0] }} 至 {{ item[1] }} 单价:{{ item[2] }}元
              </span>
        </div>
      </template>
    </af-table-column>
    <af-table-column  v-if="checkPermission(['bee:res:station:parkPricesChange'])" width="200px"  label="地锁停车费率设置">
      <template slot-scope="scope">
        <el-popover style="margin-right: 10px" placement="left" width="200" >
          <el-form :model="parkPricesForm" :rules="parkPricesFormRules" ref="parkPricesForm"  size="mini">
          <el-col>
            <el-form-item prop="parkPrices">
              <el-col v-for="(item, i) in parkPrices" :key="i">
                <el-time-select
                  class="parkPricesPicker"
                  placeholder="起始时间"
                  v-model="item[0]"
                  :picker-options="{
                            start: '00:00',
                            step: '01:00',
                            end: '24:00',
                            minTime:
                              i > 0 && parkPrices[i - 1][1]
                                ? parkPrices[i - 1][1].split(':')[0] +
                                  ':' +
                                  (parkPrices[i - 1][1].split(':')[1] - 1)
                                : '',
                          }"
                ></el-time-select>
                <el-time-select
                  class="parkPricesPicker"
                  placeholder="结束时间"
                  v-model="item[1]"
                  :picker-options="{
                            start: '00:00',
                            step: '01:00',
                            end: '24:00',
                            minTime: parkPrices[i][0],
                          }"
                ></el-time-select>
                <el-input autocomplete="off" v-model="item[2]" placeholder="单价(元)"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item
              hidden
              label="id"
              :label-width="formLabelWidth"
              prop="id"
            >
              <el-input
                v-model="parkPricesForm.id"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form>
          <div style="text-align: center">
            <el-button
              type="success"
              size="mini"
              @click="addParkPrices"
            >添加</el-button
            >
            <el-button
              type="danger"
              size="mini"
              @click="deleteParkPrices"
            >删除</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="parkPricesSubmit(scope.$index, scope.row)"
              :loading="parkPricesSubmitLoading"
            >设置</el-button
            >
          </div>
          <el-button
            slot="reference"
            size="mini"
            class="parkPrices"
            plain
            @click="parkPricesCharging(scope.$index, scope.row)"
          >设置地锁费率
          </el-button>
        </el-popover>
      </template>
    </af-table-column>
    <af-table-column label="操作" width="320px">
      <template slot-scope="scope">
<!--        <template v-if="scope.row.serviceBillingRulesId != null">
          <el-button size="mini" type="success" @click="rateEdit(scope.row.serviceBillingRulesId)">费率修改</el-button>
        </template>-->
        <el-button size="mini" plain @click="showViewVisible(scope.$index, scope.row)"
                   >视图
        </el-button>
        <el-button size="mini" plain @click="stationEdit(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:station:updateStation'])">编辑
        </el-button>
        <el-button size="mini" plain type="danger" @click="stationDelete(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:station:deleteStation'])">删除
        </el-button>
      </template>
    </af-table-column>
  </el-table>
</template>

<script>
  import stationApi from '../../../resourceCenter/api/stationApi'
  export default {
    name: "list",
    data(){
      return{
        parkPricesFormRules: {
          parkPrices: [
            {
              require: true,
              message: "时间不能为空",
              trigger: "blur",
            },
          ],
        },
        formLabelWidth: "150px",
        parkPricesForm: {},
        parkPricesSubmitLoading: false,
        parkPrices: [["00:00", "24:00",0]],
      }
    },
    props:{
      tableData: {},
      stationsLoading: false,
    },
    methods:{
      parkPricesCharging(index, row) {
        console.log(row.parkPrices);
        if (row.parkPrices == "" || row.parkPrices == null) {
          this.parkPrices = [["00:00", "24:00",0]];
        } else {
          this.parkPrices = JSON.parse(row.parkPrices);
          console.log(this.parkPrices);
        }
      },
      parkPricesSubmit(index, row) {
        this.parkPricesForm = {
          id: row.id,
          parkPrices: JSON.stringify(this.parkPrices),
        };
        let lt = this.parkPrices;
        let flag = false;
        let msg = "";
        for (var i = 0; i < lt.length; i++) {
          msg =
            lt[i][0] === null || lt[i][1] === null
              ? "设置限时时间段不能为空！"
              : "";
          if (msg !== "") {
            break;
          }
          for (var j = 0; j < lt.length; j++) {
            if (i != j) {
              flag =
                (lt[i][0] > lt[j][0] && lt[i][0] < lt[j][1]) ||
                (lt[i][1] > lt[j][0] && lt[i][1] < lt[j][1]);
              if (flag) {
                break;
              }
            }
          }
        }

        if (msg !== "" || flag) {
          this.$message.error(msg !== "" ? msg : "设置时间段重叠哦！");
          return;
        }
        this.$confirm("确认提交吗？", "提示", {}).then(() => {
          this.parkPricesSubmitLoading = true;
          let param = JSON.stringify(this.parkPricesForm);
          stationApi.parkPricesChange(param).then((res) => {
            this.parkPricesSubmitLoading = false;
            if (res.code === 0) {
              this.$message({
                message: res.message,
                type: "success",
              });
              this.submitStationSearchForm();
            } else {
              this.$message.error(res.message);
            }
          });
        });
      },
      addParkPrices() {
        let length = this.parkPrices.length;
        if (length < 4) {
          console.log("length:" + length);
          if (length > 0) {
            console.log(this.parkPrices[length - 1][1]);
            if (this.parkPrices[length - 1][1] != "24:00") {
              this.parkPrices.push([this.parkPrices[length - 1][1], "24:00"]);
            } else {
              this.$message.error("最晚时间已经是24:00了哦！");
            }
          } else {
            this.parkPrices.push(["00:00", "24:00",0]);
          }
        } else {
          this.$message.error("不要添加太多");
        }
      },
      deleteParkPrices() {
        this.parkPrices.splice(this.parkPrices.indexOf(["00:00", "24:00",0]), 1);
      },
      showViewVisible(index,row){
        this.$emit('showViewVisible',index,row)
      },
      stationEdit(index,row){
        this.$emit('stationEdit',index,row)
      },
      rateEdit(rateId){
        this.$emit('rateEdit',rateId)
      },
      stationDelete(index,row){
        this.$emit('stationDelete',index,row)
      },
      submitStationSearchForm() {
        this.$emit('submitStationSearchForm')
      }
    },
    filters: {
      statusFilter(stationStatus) {
        const statusMap = {
          0: 'warning',
          1: 'primary',
          5: 'info',
          6: 'danger',
          50: 'success'
        }
        return statusMap[stationStatus]
      }
    }
  }
</script>

<style scoped>
  .parkPricesPicker {
    width: 96px !important;
    margin-bottom: 2px;
  }

  .parkPrices {
    background-color: #d949c8;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/siteManager/list.vue